import { render, staticRenderFns } from "./BanksFilter.vue?vue&type=template&id=c282eefc&"
import script from "./BanksFilter.vue?vue&type=script&lang=js&"
export * from "./BanksFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports